var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock-icon",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("../../../../assets/images/icon_dkjl.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }